<template>
  <div style="width: 100%;" :class="{english:lang=='EN'}">
    <div class="hidden-xs">
      <div class="job-offer">
        <div class="wow fadeInUp" style="display: flex;align-items: center;flex-direction: column;">
          <div class="title">{{$t('joinUs.Position')}}</div>
        </div>
        <table class="table-ui">
          <thead class="head">
          <tr>
            <th width="45%">{{$t('joinUs.post')}}</th>
            <th width="20%">{{$t('joinUs.site')}}</th>
            <th width="45%">{{$t('joinUs.apply')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in offers">
            <td style="display:flex;justify-content: center;align-items: center;">
              <div style="width: 100%;max-width:22.5rem;text-align: left;">
                {{$t(item.post)}}
              </div>
            </td>
            <td>{{$t(item.workPlace)}}</td>
            <td class="operate" @click="openLink(item.link)">{{$t('joinUs.applyNow')}}</td>
          </tr>
          </tbody>
        </table>
        <div class="job-offer-footer">
          <span>{{$t('joinUs.tip4')}}</span>
          <div>
            <a href="Mailto:hr@mindpointeye.com">hr@mindpointeye.com</a>
          </div>
          <span>{{$t('joinUs.tip5')}}</span>
          <img src="../../../assets/img/common/or_code.png">
        </div>
      </div>
    </div>
    <div class="visible-xs">
      <div class="job-offer">
        <div class="wow fadeInUp" style="display: flex;align-items: center;flex-direction: column;">
          <div class="title">{{$t('joinUs.Position')}}</div>
        </div>
        <table class="table-ui">
          <thead class="head">
          <tr>
            <th width="50%">{{$t('joinUs.post')}}</th>
            <th width="20%">{{$t('joinUs.site')}}</th>
            <th width="20%">{{$t('joinUs.apply')}}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in offers">
            <td style="display:flex;justify-content: center;align-items: center;">
              <div style="width: 100%;max-width:22.5rem;text-align: left;">
                {{$t(item.post)}}
              </div>
            </td>
            <td style="border-left: 0.1rem solid #FFFFFF;border-right: 0.1rem solid #FFFFFF;">{{$t(item.workPlace)}}
            </td>
            <td class="operate" @click="openLink(item.link)">{{$t('joinUs.applyNow')}}</td>
          </tr>
          </tbody>
        </table>
        <div class="job-offer-footer">
          <span>{{$t('joinUs.tip4')}}</span>
          <div>
            <a href="Mailto:hr@mindpointeye.com">hr@mindpointeye.com</a>
          </div>
          <span>{{$t('joinUs.tip5')}}</span>
          <img src="../../../assets/img/common/or_code.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'JobOffer',
    components: {},
    props: {},
    data () {
      return {
        offers: [
          {
            post: 'joinUs.message1.message1',
            workPlace: 'joinUs.message1.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244607310.htm'
          },
          {
            post: 'joinUs.message2.message1',
            workPlace: 'joinUs.message2.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244609810.htm'
          },
          {
            post: 'joinUs.message3.message1',
            workPlace: 'joinUs.message3.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244536210.htm'
          },
          {
            post: 'joinUs.message5.message1',
            workPlace: 'joinUs.message5.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244618910.htm'
          },
          {
            post: 'joinUs.message6.message1',
            workPlace: 'joinUs.message6.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244599510.htm'
          },
          {
            post: 'joinUs.message7.message1',
            workPlace: 'joinUs.message7.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244597710.htm'
          },
          {
            post: 'joinUs.message8.message1',
            workPlace: 'joinUs.message8.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244543710.htm'
          },
          {
            post: 'joinUs.message9.message1',
            workPlace: 'joinUs.message9.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244632810.htm'
          },
          {
            post: 'joinUs.message10.message1',
            workPlace: 'joinUs.message10.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244608610.htm'
          },
          {
            post: 'joinUs.message11.message1',
            workPlace: 'joinUs.message11.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244605410.htm'
          },
          {
            post: 'joinUs.message12.message1',
            workPlace: 'joinUs.message12.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244600410.htm'
          },
           {
            post: 'joinUs.message13.message1',
            workPlace: 'joinUs.message13.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244625810.htm'
          },
          {
            post: 'joinUs.message14.message1',
            workPlace: 'joinUs.message14.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244554610.htm'
          },
          {
            post: 'joinUs.message15.message1',
            workPlace: 'joinUs.message15.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244548510.htm'
          },
          {
            post: 'joinUs.message16.message1',
            workPlace: 'joinUs.message16.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244553910.htm'
          },
          {
            post: 'joinUs.message17.message1',
            workPlace: 'joinUs.message17.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244629910.htm'
          },
          {
            post: 'joinUs.message18.message1',
            workPlace: 'joinUs.message18.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244549610.htm'
          },
          {
            post: 'joinUs.message19.message1',
            workPlace: 'joinUs.message19.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244537310.htm'
          },
          {
            post: 'joinUs.message20.message1',
            workPlace: 'joinUs.message20.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244503410.htm'
          },
          {
            post: 'joinUs.message22.message1',
            workPlace: 'joinUs.message22.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244506510.htm'
          },
           {
            post: 'joinUs.message23.message1',
            workPlace: 'joinUs.message23.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244514910.htm'
          },
           {
            post: 'joinUs.message24.message1',
            workPlace: 'joinUs.message24.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244531010.htm'
          },
           {
            post: 'joinUs.message25.message1',
            workPlace: 'joinUs.message21.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244509310.htm'
          },
           {
            post: 'joinUs.message26.message1',
            workPlace: 'joinUs.message26.message2',
            link: 'https://jobs.zhaopin.com/CC457741984J00244516210.htm'
          },
          //  {
          //   post: 'joinUs.message27.message1',
          //   workPlace: 'joinUs.message27.message2',
          //   link: 'https://jobs.zhaopin.com/CC457741984J00244509310.htm'
          // },
          //  {
          //   post: 'joinUs.message28.message1',
          //   workPlace: 'joinUs.message28.message2',
          //   link: 'https://jobs.zhaopin.com/CC457741984J00244509310.htm'
          // },
          //  {
          //   post: 'joinUs.message29.message1',
          //   workPlace: 'joinUs.message29.message2',
          //   link: 'https://jobs.zhaopin.com/CC457741984J00244509310.htm'
          // },
          //  {
          //   post: 'joinUs.message30.message1',
          //   workPlace: 'joinUs.message30.message2',
          //   link: 'https://jobs.zhaopin.com/CC457741984J00244509310.htm'
          // },
        ]
      }
    },
    methods: {
      openLink (link) {
        if (link) {
          window.open(link)
        } else {
          alert(this.$i18n.t('joinUs.tip6'))
        }
      }
    },
    mounted () {

    },
    computed: {
      ...mapGetters(['lang']),
      getComponentName () {
        return 'JobOffer'
      }
    }

  }
</script>

<style lang="scss" scoped>
  .job-offer {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 8rem;

    .title {
      font-size: 3rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(63, 74, 93, 1);
      line-height: 4.38rem;
    }

    .underline {
      max-width: 9.75rem;
      margin-top: 1.5rem;
    }

    .table-ui {
      width: 100%;
      max-width: 75rem;
      text-align: center;
      margin-top: 6rem;

      .head {
        height: 3.75rem;
        background: linear-gradient(90deg, rgba(59, 73, 98, 1) 0%, rgba(29, 38, 50, 1) 100%);
        font-size: 1.125rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        line-height: 4.38rem;
      }

      th {
        text-align: center;
      }

      tbody {
        tr {
          height: 5.25rem;
          height: 1.065rem;
          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 300;
          color: rgba(63, 74, 93, 1);
          line-height: 4.38rem;
          border-top: 0.06rem solid rgba(232, 233, 237, 1);

          .operate {
            cursor: pointer;
          }

          .operate:hover {
            color: #2B9EFF;
          }
        }
      }
    }

    .job-offer-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 1.5rem 0 3.75rem 0;
      font-size: 1rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 3.13rem;
      letter-spacing: 0.075rem;

      a {
        font-weight: bold;
        text-decoration: underline;
        color: rgba(51, 51, 51, 1);
        letter-spacing: 0.075rem;
        cursor: pointer;
        margin: 0 0.375rem;
      }

      a:hover, a:active {
        color: #2B9EFF;
      }

      img {
        width: 7.5rem;
        height: 7.5rem;
        margin-left: 1.5rem;
      }
    }
  }

  .visible-xs {
    .job-offer {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 2rem;

      .title {
        font-size: 1.5rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        color: rgba(63, 74, 93, 1);
        line-height: 3rem;
      }

      .underline {
        max-width: 9.75rem;
        margin-top: 1.5rem;
      }

      .table-ui {
        width: 100%;
        max-width: 100%;
        text-align: center;
        margin-top: 2rem;

        .head {
          height: 3.75rem;
          background: rgba(59, 73, 98, 1);
          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 3.5rem;
        }

        th {
          text-align: center;
        }

        tbody {
          tr {
            font-size: 0.8rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 300;
            color: rgba(63, 74, 93, 1);
            line-height: 1.5rem;
            border-bottom: 0.1rem solid #FFFFFF;

            td {
              padding: 0.5rem;
            }

            .operate {
              cursor: pointer;
            }

            .operate:hover {
              color: #2B9EFF;
            }
          }
        }
      }

      .job-offer-footer {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 1rem 0 2rem 0;
        font-size:0.8rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height:1.5rem;
        letter-spacing: 0.075rem;
        flex-direction: column;

        a {
          font-weight: bold;
          text-decoration: underline;
          color: rgba(51, 51, 51, 1);
          letter-spacing: 0.075rem;
          cursor: pointer;
          margin: 0;
        }

        a:hover, a:active {
          color: #2B9EFF;
        }

        img {
          width: 7.5rem;
          height: 7.5rem;
          margin-left: 0rem;
        }
      }
    }
  }

  .english {
    .job-offer-footer {
      letter-spacing: 0 !important;
    }

    .hidden-xs {
      .job-offer .table-ui tbody tr {
        line-height: 2rem !important;

        td {
          padding: 1rem 0;
        }
      }
    }

    .visible-xs {
      .job-offer .table-ui tbody tr {
        line-height: 1.3rem !important;

        td {
          padding: 1rem;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/joinus/JobOffer.vue